import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AbsenceTypeService = {
    list: () => axios.get(`${API_KEEPER}/absence-types`).then(({data}) => data),
    get: (id) => axios.get(`${API_KEEPER}/absence-types/${id}`).then(({data}) => data),
    isInUse: (id) => axios.get(`${API_KEEPER}/absence-types/${id}/in-use`).then(({data}) => data),
    create: (data) => axios.post(`${API_KEEPER}/absence-types`, data).then(({data}) => data),
    update: (id, data) => axios.put(`${API_KEEPER}/absence-types/${id}`, data).then(({data}) => data),
    delete: (id) => axios.delete(`${API_KEEPER}/absence-types/${id}`),
};

export default AbsenceTypeService;
